// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"2755cd86","498":"2a26f871","703":"feee136e"}[chunkId] + ".chunk.js";
};